import React from 'react';
import '../../styles/gallery/main.css';

const Main = () => {
  return (
    <div>
        <section className="gallery-main">
            <div className="container">
                <h1 className="my-heading mb-3">CULTURAL GALLERY</h1>
                <ul>
                <li>
                    <a data-bs-toggle="modal" href="#exampleModalToggle" role="button" className="btn-gallery">
                    <img src="https://ccsuniversity.blr1.cdn.digitaloceanspaces.com/public/jpg/2024/05/Sports/Cultural/1.jpg" alt="gallery" />
                    </a>
                    <a className="view_more_btn" data-bs-toggle="modal" href="#exampleModalToggle" role="button">View More</a>
                    <div>
                    <h6>Cultural</h6>
                    </div>
                </li>
                </ul>
            </div>
        </section>

        <div className="modal-main">
            <div className="modal fade" id="exampleModalToggle" aria-hidden="true" aria-labelledby="exampleModalToggleLabel"
                tabindex="-1">
                <div className="modal-dialog modal-dialog-centered">
                <div className="modal-content">
                    <div id="carouselExampleControls" className="carousel slide" data-bs-ride="carousel">
                    <div className="carousel-inner">
                        <div className="carousel-item active">
                        <img src="https://ccsuniversity.blr1.cdn.digitaloceanspaces.com/public/jpg/2024/05/Sports/Cultural/1.jpg" className="d-block w-100" alt="Cultural" />
                        </div>
                        <div className="carousel-item ">
                        <img src="https://ccsuniversity.blr1.cdn.digitaloceanspaces.com/public/jpg/2024/05/Sports/Cultural/2.jpg" className="d-block w-100" alt="Cultural" />
                        </div>
                        <div className="carousel-item ">
                        <img src="https://ccsuniversity.blr1.cdn.digitaloceanspaces.com/public/jpg/2024/05/Sports/Cultural/3.jpg" className="d-block w-100" alt="Cultural" />
                        </div>
                        <div className="carousel-item ">
                        <img src="https://ccsuniversity.blr1.cdn.digitaloceanspaces.com/public/jpg/2024/05/Sports/Cultural/4.jpg" className="d-block w-100" alt="Cultural" />
                        </div>
                        <div className="carousel-item ">
                        <img src="https://ccsuniversity.blr1.cdn.digitaloceanspaces.com/public/jpg/2024/05/Sports/Cultural/5.jpg" className="d-block w-100" alt="Cultural" />
                        </div>
                        <div className="carousel-item ">
                        <img src="https://ccsuniversity.blr1.cdn.digitaloceanspaces.com/public/jpg/2024/05/Sports/Cultural/6.jpg" className="d-block w-100" alt="Cultural" />
                        </div>
                        <div className="carousel-item ">
                        <img src="https://ccsuniversity.blr1.cdn.digitaloceanspaces.com/public/jpg/2024/05/Sports/Cultural/7.jpg" className="d-block w-100" alt="Cultural" />
                        </div>
                        <div className="carousel-item ">
                        <img src="https://ccsuniversity.blr1.cdn.digitaloceanspaces.com/public/jpg/2024/05/Sports/Cultural/8.jpg" className="d-block w-100" alt="Cultural" />
                        </div>
                        <div className="carousel-item ">
                        <img src="https://ccsuniversity.blr1.cdn.digitaloceanspaces.com/public/jpg/2024/05/Sports/Cultural/9.jpg" className="d-block w-100" alt="Cultural" />
                        </div>
                        <div className="carousel-item ">
                        <img src="https://ccsuniversity.blr1.cdn.digitaloceanspaces.com/public/jpg/2024/05/Sports/Cultural/10.jpg" className="d-block w-100" alt="Cultural" />
                        </div>
                        <div className="carousel-item ">
                        <img src="https://ccsuniversity.blr1.cdn.digitaloceanspaces.com/public/jpg/2024/05/Sports/Cultural/11.jpg" className="d-block w-100" alt="Cultural" />
                        </div>
                        <div className="carousel-item ">
                        <img src="https://ccsuniversity.blr1.cdn.digitaloceanspaces.com/public/jpg/2024/05/Sports/Cultural/12.jpg" className="d-block w-100" alt="Cultural" />
                        </div>
                        <div className="carousel-item ">
                        <img src="https://ccsuniversity.blr1.cdn.digitaloceanspaces.com/public/jpg/2024/05/Sports/Cultural/13.jpg" className="d-block w-100" alt="Cultural" />
                        </div>
                        <div className="carousel-item ">
                        <img src="https://ccsuniversity.blr1.cdn.digitaloceanspaces.com/public/jpg/2024/05/Sports/Cultural/14.jpg" className="d-block w-100" alt="Cultural" />
                        </div>
                        <div className="carousel-item ">
                        <img src="https://ccsuniversity.blr1.cdn.digitaloceanspaces.com/public/jpg/2024/05/Sports/Cultural/15.jpg" className="d-block w-100" alt="Cultural" />
                        </div>
                        <div className="carousel-item ">
                        <img src="https://ccsuniversity.blr1.cdn.digitaloceanspaces.com/public/jpg/2024/05/Sports/Cultural/16.jpg" className="d-block w-100" alt="Cultural" />
                        </div>
                        <div className="carousel-item ">
                        <img src="https://ccsuniversity.blr1.cdn.digitaloceanspaces.com/public/jpg/2024/05/Sports/Cultural/17.jpg" className="d-block w-100" alt="Cultural" />
                        </div>
                    </div>
                    <button className="carousel-control-prev" type="button" data-bs-target="#carouselExampleControls"
                        data-bs-slide="prev">
                        <span className="carousel-control-prev-icon" aria-hidden="true"></span>
                        <span className="visually-hidden">Previous</span>
                    </button>
                    <button className="carousel-control-next" type="button" data-bs-target="#carouselExampleControls"
                        data-bs-slide="next">
                        <span className="carousel-control-next-icon" aria-hidden="true"></span>
                        <span className="visually-hidden">Next</span>
                    </button>
                    <div className="close-btn-modal">
                        <button data-bs-dismiss="modal" aria-label="Close">
                            <i className="fa fa-times" aria-hidden="true" style={{ cursor: 'pointer' }}></i>
                        </button>
                    </div>
                    </div>
                </div>
                </div>
            </div>
        </div>

    </div>
  )
}

export default Main;